import { Injectable } from '@nestjs/common';
import { EntityRepository, Repository } from 'typeorm';
import { FreebiesConsumptionEntity } from '../entity/freebies-consumption.entity';
import { TokenConsumptionReportQueryResponse } from './query-response/token-cons-report.query.response';

@Injectable()
@EntityRepository(FreebiesConsumptionEntity)
export class FreebiesConsumptionRepo extends Repository<FreebiesConsumptionEntity> {

    constructor() {
        super();
    }


    /**
     * 
     * @param fromDate 
     * @param toDate 
     * @param departmentId 
     * @param freebieCategory 
     * @returns 
     */
    async getTokenConsumptionRecordsByDate(fromDate: string, toDate: string, departmentId: number, freebieCategory: string): Promise<TokenConsumptionReportQueryResponse[]> {
        const query = this.createQueryBuilder('fb_cons')
            .select(`employee_id, employee_freebies_id, CAST(DATE(created_at) AS CHAR) as date, count(1) as count, unit_price, freebie_category`)
            .where(` DATE(created_at) BETWEEN '${fromDate}' AND '${toDate}' `);
        if (departmentId) {
            query.andWhere(` department_id = ${departmentId} `)
        }
        if (freebieCategory) {
            query.andWhere(` freebie_category = '${freebieCategory}' `)
        }
        query.groupBy('DATE(created_at), freebie_category, employee_id')
            .orderBy('created_at', 'DESC')
        return await query.getRawMany();
    }

    /**
     * 
     * @param fromDate 
     * @param toDate
     * @returns 
     */
    async getTotalTokenConsumptionByDate(fromDate: string, toDate: string): Promise<TokenConsumptionReportQueryResponse[]> {
        const query = this.createQueryBuilder('fb_cons')
            .select(` freebie_category, count(1) as count, SUM(unit_price) as unit_price`)
            .where(` DATE(created_at) BETWEEN '${fromDate}' AND '${toDate}' `)
            .groupBy('freebie_category')
            .orderBy('freebie_category', 'ASC')
        return await query.getRawMany();
    }

    async getTotalTokenConsumptionByFreebieCategoryAndByDate(freebieCategory: string, fromDate: string, toDate: string): Promise<TokenConsumptionReportQueryResponse[]> {
        const query = this.createQueryBuilder('fb_cons')
            .select(` department_id, count(1) as count`)
            .where(` freebie_category = '${freebieCategory}' AND DATE(created_at) BETWEEN '${fromDate}' AND '${toDate}' `)
            .groupBy('department_id')
            .orderBy('department_id', 'ASC')
        return await query.getRawMany();
    }

    async getTokenConsumptionByDate(fromDate: string, toDate: string): Promise<TokenConsumptionReportQueryResponse[]> {
        const query = this.createQueryBuilder('fb_cons')
            .select(` freebie_category, count(1) as count, CAST(DATE(created_at) AS CHAR) as date`)
            .where(` DATE(created_at) BETWEEN '${fromDate}' AND '${toDate}' `)
            .groupBy(`DATE(created_at), freebie_category`)
        return await query.getRawMany();
    }
}
